import { render, staticRenderFns } from "./OrderCreated.vue?vue&type=template&id=8a865408"
import script from "./OrderCreated.vue?vue&type=script&lang=js"
export * from "./OrderCreated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports